import React from "react";
import styled from "styled-components";
import Container from "./Container";
import ContentBlock from "./ContentBlock";

const CtaWrapper = styled.div`
  background-color: ${props => props.theme.colors.blue};
  position: relative;
`;

const Cta = props => (
  <CtaWrapper>
    <Container>
      <ContentBlock
        smallMargin={true}
        fullWidth={true}
        diapositive={true}
        title={props.cta[0].node.title}
        src={
          props.cta[0].node.buttonUrl.childMarkdownRemark.rawMarkdownBody
        }
        buttonText={props.cta[0].node.buttonText}
      />
    </Container>
  </CtaWrapper>
);

export default Cta;



// WEBPACK FOOTER //
// ./src/components/Cta.js